import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

  private path = (location.hostname === 'localhost')  ? 'https://dev5.bats.admin.ufl.edu' : 'https://' + location.hostname;

  private whoAmIAPI = this.path + '/cleryadmin/api/whoami';
  private excelAPI = this.path + '/library/api/getExcel';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient) {}

  /** GET whoami data from shib */
  getWhoAmI(): Observable<object> {
    return this.http.get<object>(this.whoAmIAPI)
    .pipe(
      catchError(this.handleError<object>('whoami'))
    );
  }

    /** GET excel from the server */
    getExcel(data): Observable<object> {
      return this.http.post<object>(this.excelAPI, data)
      .pipe(
        catchError(this.handleError<object>('getExcel'))
      );
    }


  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
